import React from "react";
import { Col, Icon, Row, Spin } from "antd";
import styles from "./index.module.scss";

import EvaluationCard from "./components/EvaluationCard";
import useRequest from "utils/useRequest";
import { paperEvaluationList } from "service/exam";
import CustomEmpty from "components/CourseComponents/CustomEmpty";

export default function MyEvaluation() {
    const [data, { loading }, refresh] = useRequest(() =>
        paperEvaluationList()
    );

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <a href="/assets/教学检查试卷检查报告单模板.docx">
                    <Icon type="file-done" /> 下载试卷检查报告模板
                </a>
            </div>

            <Spin spinning={loading}>
                <Row gutter={[30, 30]} type="flex">
                    {data?.map(item => (
                        <Col key={item.evaluationId} span={8}>
                            <EvaluationCard data={item} onChange={refresh} />
                        </Col>
                    ))}
                </Row>

                {!data?.length && (
                    <CustomEmpty
                        style={{ padding: "100px 0" }}
                        description="无数据"
                    />
                )}
            </Spin>
        </div>
    );
}
